import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M6 0C2.68661 0 0 2.68661 0 6C0 9.31339 2.68661 12 6 12C9.31339 12 12 9.31339 12 6C12 2.68661 9.31339 0 6 0ZM5.46429 8.625L4.39286 7.575L2.25 5.475L3.32143 4.425L5.46429 6.525L8.67857 3.375L9.75 4.425L5.46429 8.625Z"
        fill="#13CB75"
      />
    </svg>
  );
}

export default Icon;
